import { useEffect } from "react";

export const useFavicon = (url?: string) => {
  useEffect(() => {
    if (!url) return;

    const link =
      (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
      document.createElement("link");
    link.rel = "shortcut icon";
    link.href = url;

    document.getElementsByTagName("head")[0].appendChild(link);
  }, [url]);
};
